import React from "react";
import { useSelector } from "react-redux";
import Button from "../Widgets/Button";
import { ReactComponent as HamburgerMenuSVG } from "../../imges/HamburgerMenu.svg";
import { ReactComponent as PlaceholderSVG } from "../../imges/placeholder.svg";
import Styles from "./styles.module.scss";

interface INavigationHeaderProps {
  demo?: boolean;
  backURL: Function;
  openSideDrawer: Function;
  displayVenueImage?: boolean;
}

function NavigationHeader({
  demo = false,
  backURL,
  openSideDrawer,
  displayVenueImage = true,
}: INavigationHeaderProps) {
  const Venue = useSelector((state: any) => state.Venue);
  return (
    <div className={Styles.NavigationHeader}>
      <div>
        {!demo ? (
          <Button
            iconClassName="consumer-left-arrow"
            onClick={() => backURL()}
            dataComponentName={"BackButton"}
            style={{ color: "#000000", fontSize: "1.5rem", position: "unset" }}
            isHeaderBtn
          />
        ) : null}
      </div>
      <div className={Styles.headerConteiner}>
        {displayVenueImage === true &&
          (Venue.url_logo ? (
            <img src={Venue.url_logo} alt="" />
          ) : (
            <PlaceholderSVG />
          ))}
      </div>
      <div>
        {!demo ? (
          <Button
            Icon={<HamburgerMenuSVG />}
            dataComponentName={"HamburgerMenu"}
            style={{ background: "unset", position: "unset" }}
            //@ts-ignore
            onClick={openSideDrawer}
            isHeaderBtn
          />
        ) : null}
      </div>
    </div>
  );
}

export default NavigationHeader;
